// DOM content loaded event listener
document.addEventListener("DOMContentLoaded", function () {
  const sectionHero = document.querySelector(".section-hero");
  const sectionAbout = document.querySelector(".section-about");

  if (sectionHero && sectionAbout) {
    const track = sectionHero.querySelector(".images");
    const slides = Array.from(sectionHero.querySelectorAll(".image-slide"));

    if (slides.length <= 1) return;

    const wrapper = sectionHero.querySelector(".images-wrapper");
    const current = sectionAbout.querySelector(".current");
    const total = sectionAbout.querySelector(".total");
    const progressBar = sectionAbout.querySelector(".progress-fill");
    const btnNext = sectionAbout.querySelector(".arrow-next");
    const btnPrev = sectionAbout.querySelector(".arrow-prev");

    let currentSlider = 1;
    let touchStartX = 0;
    let mouseStartX = 0;
    let isDragging = false;
    track.style.transform = `translateX(-100%)`;

    const numberOfSlides = slides.length;
    const firstClonedSlider = slides[0].cloneNode(true);
    const lastClonedSlide = slides[numberOfSlides - 1].cloneNode(true);
    track.appendChild(firstClonedSlider);
    track.prepend(lastClonedSlide);

    let isAnimating = false;

    // TOTAL
    total.textContent = numberOfSlides;

    // PROGRESS BAR
    const updatedProgresBar = (currentSlider) => {
      let realIndex = currentSlider;
      if (currentSlider === 0) realIndex = numberOfSlides;
      if (currentSlider === numberOfSlides + 1) realIndex = 1;

      const value = (realIndex / numberOfSlides) * 100;
      progressBar.style.width = `${value}%`;
      current.textContent = realIndex;
    };
    // SLIDER NEXT
    const nextSlide = () => {
      if (isAnimating) return;
      isAnimating = true;
      currentSlider++;
      const value = currentSlider * -100;
      track.style.transform = `translateX(${value}%)`;
      updatedProgresBar(currentSlider);
    };

    // SLIDER PREV
    const prevSlide = () => {
      if (isAnimating) return;
      isAnimating = true;
      currentSlider--;
      const value = currentSlider * -100;
      track.style.transform = `translateX(${value}%)`;
      updatedProgresBar(currentSlider);
    };

    track.addEventListener("transitionend", () => {
      isAnimating = false;
      if (currentSlider === numberOfSlides + 1) {
        track.style.transition = "none";
        currentSlider = 1;
        track.style.transform = `translateX(-100%)`;
        setTimeout(() => (track.style.transition = ""), 10);
      }
      if (currentSlider === 0) {
        track.style.transition = "none";
        currentSlider = numberOfSlides;
        track.style.transform = `translateX(${-currentSlider * 100}%)`;
        setTimeout(() => (track.style.transition = ""), 10);
      }
    });

    wrapper.addEventListener("touchstart", (e) => {
      touchStartX = e.touches[0].clientX;
    });

    wrapper.addEventListener("touchend", (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      if (touchStartX - touchEndX > 50) nextSlide();
      if (touchEndX - touchStartX > 50) prevSlide();
    });

    wrapper.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      e.preventDefault();
      mouseStartX = e.clientX;
      isDragging = true;
    });

    wrapper.addEventListener("mouseup", (e) => {
      if (!isDragging) return;
      const mouseEndX = e.clientX;
      if (mouseStartX - mouseEndX > 50) nextSlide();
      if (mouseEndX - mouseStartX > 50) prevSlide();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") nextSlide();
      if (e.key === "ArrowLeft") prevSlide();
    });

    btnNext.addEventListener("click", nextSlide);
    btnPrev.addEventListener("click", prevSlide);

    function init() {
      updatedProgresBar(currentSlider);
    }

    init();
  }
});
